import { useCallback, useState } from 'react';

import type {
  MonthData,
  UseSalaryInfoProps,
} from '@app/pages/Users/UserProfile/components/SalaryInfo/types';
import { transformData } from '@app/pages/Users/UserProfile/components/SalaryInfo/utils';

export const useSalaryInfo = ({ data }: UseSalaryInfoProps) => {
  const initialData: MonthData[] =
    data?.Salaries?.filter((salary) => salary.Amount !== 0).map(
      (salary, index) => ({
        key: index.toString(),
        month: transformData(salary.Label ?? ''),
        amount: salary.Amount,
        confirmed: salary.IsConfirmed,
      })
    ) || [];

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);

  const openConfirmModal = useCallback((key: string) => {
    setSelectedRowIndex(Number(key));
    setIsConfirmModalOpen(true);
  }, []);

  return {
    initialData,
    openConfirmModal,
    isConfirmModalOpen,
    setIsConfirmModalOpen,
    selectedRowIndex,
    setSelectedRowIndex,
  };
};
